<template>
    <button class="btn btn-sm btn-primary" :disabled=" ! this.$root.$data.enableCommit" type="submit">
        <span class="fa fa-upload dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Commit Changes</button>
</template>
<script>
    export default {
        props: {
            isGridUpdated: {
                required: true,
                type: Boolean
            },
        },
        mounted() {
            this.$root.$data.enableCommit = this.isGridUpdated;
        }
    }
</script>
